import React from 'react';
import PropTypes from 'prop-types';

export default class RadioGroup extends React.Component {

    static propTypes = {
        value: PropTypes.any,
        items: PropTypes.array.isRequired,

        disabled: PropTypes.bool,

        onChange: PropTypes.func.isRequired,
    }

    static defaultProps = {
        disabled: false,
    }

    state = {
        value: this.props.value
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if ('value' in nextProps && this.state.value !== nextProps.value) {
            this.setState({ value: nextProps.value });
        }
    }

    onOptionClick = (value) => {
        if (this.props.disabled) return;

        this.setState({value}, ()=>{this.props.onChange(value)});
    }

    render() {
        const classes = Classes('gd-radio-group', this.props.className, {
            'is-disabled': this.props.disabled,
        });

        return (
            <div className={classes}>
                {_.map(this.props.items, item => {
                    const optionClasses = Classes('radio-option', {
                        'is-selected': item.value === this.state.value,
                        'is-disabled': !!item.disabled
                    });
                    return (
                        <div key={item.value} className={optionClasses} onClick={!!item.disabled ? null : () => this.onOptionClick(item.value)}>
                            <div className="option-icon" />
                            <div className="option-label">{item.label}</div>
                            {item.description && <div className="option-description">{item.description}</div>}
                        </div>
                    )
                })}
            </div>
        )
    }
}